import styled, { css, keyframes } from 'styled-components';
// styles
import { mediaQuery, palette, zIndex } from '../styles';

interface Props {
  animated: 'OPEN' | 'CLOSE' | 'NONE';
}

const AnimeFadeIn = keyframes`
	from { opacity: 0; }
	to { opacity 1; }
`;

const AnimeFadeOut = keyframes`
	from { opacity: 1; }
	to { opacity 0; }
`;

const Background = styled.div<Props>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  background-color: ${palette.dim.basic};
  z-index: ${zIndex.modal};
  overflow: hidden;
  ${({ animated }) => {
    if (animated === 'OPEN') {
      return css`
        animation: ${AnimeFadeIn} 0.1s;
      `;
    }
    if (animated === 'CLOSE') {
      return css`
        animation: ${AnimeFadeOut} 0.1s;
      `;
    }
  }};
  animation-fill-mode: forwards;

  ${mediaQuery.large} {
    display: none;
  }

  &:after {
    content: '';
    min-height: inherit;
    font-size: 0;
  }
`;

export default Background;
